/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Sales {
    import fld = ApprovalOutReturnBOMRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ApprovalOutReturnBOMEditor extends _Ext.BOMGridEditor<ApprovalOutReturnBOMRow> { 
        protected getDialogType() { return ApprovalOutReturnBOMDialog; }
        protected getLocalTextPrefix() { return ApprovalOutReturnBOMRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });            
        } 
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

    }
}